import { G } from '@mobily/ts-belt';
const hashString = async (str: string | null | undefined) => {
  if (G.isNullable(str) || str === '') {
    return undefined;
  }
  try {
    const encoder = new TextEncoder();
    const data = encoder.encode(str);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  } catch {
    return undefined;
  }
};
export default hashString;